<template>
    <div>
        <ul id="nav">
            <li><a href="javascript:;" @click="linkTo(1)">活动介绍</a></li>
            <li><a href="javascript:;" @click="linkTo(2)">参赛证</a></li>
            <li><a href="javascript:;" @click="linkTo(3)">比赛成绩</a></li>
            <li class="current"><a href="javascript:;"><i></i>我的团队</a></li>
        </ul>

        <div class="container">
            <div class="section">
                <h2 class="section-title">我的团队</h2>
                <div class="line clearfix">
                    <span class="label">组别</span>
                    <span class="name">{{leaderObj.teamId}}组</span>
                </div>
                <div class="line clearfix">
                    <span class="label">队长</span>
                    <span class="name inaline">{{leaderObj.name}}</span>
                    <!-- <span class="status"></span>
          <span class="handle"></span> -->
                </div>
                <div class="line clearfix" v-for="(list,index) in memberArr"  :key="index">
                    <span class="label">队员</span>
                    <span class="name inaline">{{list.invite_realname}}</span>
                    <span class="status">
                        <span v-if="list.invite_state=='p'">邀约中</span>
                        <span v-if="list.invite_state=='n'">拒绝/超时</span>
                        <span v-if="list.invite_state=='y'">同意邀约</span>
                    </span>
                    <span class="handle" v-if="list.invite_state=='n'&&isLeader" @click="inviteAgain(list)">再次邀约</span>
                </div>
                <div class="add-invite">
                    <span class="add-btn" @click="toInvite" v-if="isLeader&&isAllowAddInvite=='y'">新增邀约</span>
                </div>
                <div class="t_status" v-if="showLabel">
                    <img v-if="teamStatus == 1 && isAdvanced == '' && prize == ''" src="../assets/t_success_combine.png" alt="">
                    <img v-if="teamStatus == 1 && isAdvanced == 1  && prize == ''" src="../assets/t_success_pass.png" alt="">
                    <img v-if="teamStatus == 1 && isAdvanced == 2" src="../assets/t_fail_pass.png" alt="">
                    <img v-if="teamStatus == 1 && isAdvanced == 1 && prize == 1" src="../assets/t_first_prize.png" alt="">
                    <img v-if="teamStatus == 1 && isAdvanced == 1 && prize == 2" src="../assets/t_second_prize.png" alt="">
                    <img v-if="teamStatus == 1 && isAdvanced == 1 && prize == 3" src="../assets/t_third_prize.png" alt="">
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import {
        getMyTeamInfo,reInvitation, myGrades //获取邀约信息，再次邀约
    } from '@/api/index'
    export default {
        name: 'index',
        data() {
            return {
                leaderObj:{},
                memberArr:[],
                isAllowAddInvite:'',//是否允许新增邀约，y是允许，其他不允许
                isLeader:'',//该用户是否是队长，如果不是所有按钮隐藏
                isAdvanced: '',
                prize: '',
                showLabel: false
            }
        },
        created() {
            this.getDetail();
            this.getScore();
        },
        computed: {
            teamStatus() {
                if (this.memberArr.every(item => item.invite_state == 'y')) {
                    return 1
                } else {
                    return 0
                }
            }
        },
        mounted() {
            
        },
        methods: {
            inviteAgain(list){//再次邀约该队友
                let _this=this
                reInvitation({phone:list.invite_cellphone}).then((res) => {
                    this.showLabel = true
                    if (res.errorCode == 200) {
                        this.$createToast({
                        	txt: '邀约成功',
                        	type: 'txt'
                        }).show()
                        _this.getDetail();
                        _this.getScore();
                    } else {
                        this.$createToast({
                        	txt: res.errorMsg,
                        	type: 'txt'
                        }).show()
                    }
                }).catch(err => {})
            },
            getDetail() {
                let _this=this
                getMyTeamInfo({}).then((res) => {
                    this.showLabel = true
                    if (res.errorCode == 200) {
                       var resData=JSON.parse(res.data)
                       console.log(resData)
                       _this.leaderObj=resData.leaderInfo?resData.leaderInfo:{}
                       _this.memberArr=resData.memberInfo?resData.memberInfo:[]
                       _this.isAllowAddInvite=resData.isNewLy
                       _this.isLeader=resData.leader=='leader'?true:false
                    } else {}
                }).catch(err => {})
            },
            getScore() {
                myGrades().then(res => {
                    console.log(res)
                    if (res.errorCode == 200) {
                        if (res.data.userPreResult) {
                            if (res.data.userPreResult.isAdvance == '是') {
                                this.isAdvanced = 1
                            } else {
                                this.isAdvanced = 2
                            }
                        }
                      
                        if (res.data.userFinalsResultExcel) {
                            if (res.data.userFinalsResultExcel.awarLevel == '一等奖') {
                                this.prize = 1 
                            } else if (res.data.userFinalsResultExcel.awarLevel == '二等奖') {
                                this.prize = 2 
                            } else if (res.data.userFinalsResultExcel.awarLevel == '三等奖') {
                                this.prize = 3 
                            } else {
                                this.prize = 4 
                            }
                        }

                    }
                }).catch(err => {
                    console.log(err)
                })
            },
            linkTo(index) {
                switch (index) {
                    case 1:
                        this.$router.push('/index')
                        break;
                    case 2:
                        this.$router.push('/certificate')
                        break;
                    case 3:
                        this.$router.push('/score')
                        break;
                    case 4:
                        this.$router.push('/team')
                }
            },
            toInvite() {
                this.$router.push('/add-invite')
            }
        }
    }
</script>

<style scoped>
    #nav {
        z-index: 2;
        position: fixed;
        top: 0;
        opacity: 1;
        transition: 0.5s;
        width: 100%;
        padding: 0 0.3rem;
        max-width: 768px;
        height: 0.8rem;
        background: #fff;
        box-shadow: 0 0 10px #ccc;
        display: flex;
        justify-content: space-between;
    }

    #nav li {
        line-height: 0.8rem;
        text-align: center;
    }

    #nav li a {
        text-decoration: none;
        display: block;
        color: #333;
        font-size: 0.3rem;
    }

    #nav li.current a {
        color: #de7a31;
    }

    #nav li i {
        width: 0.25rem;
        height: 0.27rem;
        display: inline-block;
        vertical-align: middle;
        margin-right: 2px;
    }

    #nav li.current i {
        background: url(../assets/icon_select.png) no-repeat;
        background-size: cover;
    }

    .container {
        padding: 1.36rem 0 0.3rem;
    }

    .section {
        padding: 0 0.4rem 0.8rem;
        position: relative;
    }

    .section-title {
        padding: 0.2rem 0 0.3rem;
        font-size: 0.4rem;
        color: #333;
    }

    .line {
        height: 0.7rem;
        line-height: 0.7rem;
        font-size: 0.3rem;
        color: #666;
        position: relative;
    }

    .line .label {
        float: left;
        font-size: 0.32rem;
        letter-spacing: 0.3rem;
        color: #333
    }

    .line .name {
        float: left;
        width: 1.6rem;
        margin-left: 0.2rem;
    }

    .line .status {
        float: left;
        color: #f85158
    }

    .line .handle {
        position: absolute;
        color: #e77830;
        border: 1px solid #e77830;
        border-radius: 0.1rem;
        width: 1.6rem;
        height: 0.6rem;
        line-height: 0.6rem;
        right: 0;
        top: 0.05rem;
        text-align: center;
    }

    .add-invite {
        padding: 1rem 0;
    }

    .add-invite .add-btn {
        color: #fff;
        background: #df7a32;
        border-radius: 0.1rem;
        width: 1.6rem;
        height: 0.6rem;
        line-height: 0.6rem;
        text-align: center;
        margin: 0 auto;
        display: block;
    }
    .t_status {
        width: 2.86rem;
        height: 2.86rem;
        position: absolute;
        right: 0.4rem;
        top: -0.4rem;
    }
    .t_status img {
        width: 100%;
    }
</style>
